import {MeasurementPrecisionTypes} from "@model";
/**
 * Every start seconds, tenth of second or hundredth of second is rounded up to the next full second, then of second
 * or hundredth of second
 */
export function milisecondsToPrecision(milliseconds: number, measurementPrecisionType: MeasurementPrecisionTypes): string {
    const millisecondsRounded = roundMilliseconds(milliseconds, measurementPrecisionType);

    const hours = Math.floor(millisecondsRounded / 3600000).toString().padStart(2, '0');
    const minutes = Math.floor((millisecondsRounded % 3600000) / 60000).toString().padStart(2, '0');
    const seconds = Math.floor((millisecondsRounded % 60000) / 1000).toString().padStart(2, '0');
    const msRemainder = millisecondsRounded % 1000;

    let fractional = '';
    switch (measurementPrecisionType) {
        case MeasurementPrecisionTypes.TENTHS:
            fractional = '.' + Math.round(msRemainder / 100).toString();
            break;
        case MeasurementPrecisionTypes.HUNDREDTHS:
            fractional = '.' + Math.round(msRemainder / 10).toString().padStart(2, '0');
            break;
        case MeasurementPrecisionTypes.THOUSANDTHS:
            fractional = '.' + msRemainder.toString().padStart(3, '0');
            break;
    }

    return `${hours}:${minutes}:${seconds}${fractional}`;
}

function roundMilliseconds(milliseconds: number, precision: MeasurementPrecisionTypes): number {
    switch (precision) {
        case MeasurementPrecisionTypes.SECONDS:
            return Math.ceil(milliseconds / 1000) * 1000;
        case MeasurementPrecisionTypes.TENTHS:
            return Math.ceil(milliseconds / 100) * 100;
        case MeasurementPrecisionTypes.HUNDREDTHS:
            return Math.ceil(milliseconds / 10) * 10;
        case MeasurementPrecisionTypes.THOUSANDTHS:
            return milliseconds; // No rounding needed for thousandths
        default:
            throw new Error("Unsupported precision type");
    }
}